import { __read } from "tslib";
import { extractGroupBySettings } from '@keen.io/query';
import { KEEN_KEY } from '@keen.io/parser';
import { chronologicalTransformation } from './chronological-transformation';
import { categoricalTransformation } from './categorical-transformation';
import { categoricalChronologicalTransformation } from './categorical-chronological-transformation';
export var transform = function (_a) {
    var query = _a.query, chartSettings = _a.chartSettings;
    var keys = chartSettings.keys, data = chartSettings.data, tooltipSettings = chartSettings.tooltipSettings, stackMode = chartSettings.stackMode;
    var valueFormatter = tooltipSettings === null || tooltipSettings === void 0 ? void 0 : tooltipSettings.formatValue;
    var isFunnel = !query;
    if (isFunnel) {
        var _b = __read(keys, 1), valueSelector_1 = _b[0];
        return data.map(function (item) { return [item[KEEN_KEY], item[valueSelector_1]]; });
    }
    else {
        var interval = query.interval, groupBy = query.group_by;
        var isChronologicalAnalysis = !!interval;
        var isCategoricalAnalysis = groupBy && extractGroupBySettings(groupBy).length > 0;
        if (isChronologicalAnalysis && isCategoricalAnalysis) {
            return categoricalChronologicalTransformation(data, keys, valueFormatter, extractGroupBySettings(groupBy), stackMode === 'percent');
        }
        else if (isCategoricalAnalysis) {
            return categoricalTransformation(data, keys, valueFormatter, extractGroupBySettings(groupBy), stackMode === 'percent');
        }
        else {
            return chronologicalTransformation(data, keys, valueFormatter);
        }
    }
};
